import React from "react";
import axios from "axios";
import { useParams, useHistory } from "react-router-dom";

import { fetchCategoryList } from "category";
import { fetchBroadcastChannelList } from "broadcastChannel";
import { fetchTagList } from "tag";
import { AuthContext } from "auth";
import { List } from "components/program/List";
import { CreateForm } from "components/program/CreateForm";
import { Details } from "components/program/Details";

export function ProgramList() {
  const [state, dispatch] = React.useReducer(
    (s, action) => {
      switch (action.type) {
        case "FETCH_SUCCESS":
          return {
            ...s,
            programList: action.programList,
            categoryList: action.categoryList,
            websiteUrl: action.url,
            isProcessing: false,
            isError: false,
            page: 1,
            isLastPage: action.isLastPage,
          };
        case "FETCH_ERROR":
          return {
            ...s,
            isProcessing: false,
            isError: true,
          };
        case "DELETED_SUCCESS":
          return {
            ...s,
            programList: action.programList,
            isLastPage: action.isLastPage,
            isProcessing: false,
            isError: false,
          };
        case "DELETED_ERROR":
          return {
            ...s,
            isProcessing: false,
            isError: true,
          };
        case "SEARCH_SUCCESS":
          return {
            ...s,
            programList: action.programList,
            isLastPage: action.isLastPage,
            searchText: action.searchText,
            isError: false,
            isProcessing: false,
            page: 1,
          };
        case "SEARCH_ERROR":
          return {
            ...s,
            isProcessing: false,
            isError: true,
          };
        case "PAGE_CHANGED":
          return {
            ...s,
            page: action.page,
            programList: action.programList,
            isLastPage: action.isLastPage,
          };
        default:
          return s;
      }
    },
    {
      programList: [],
      categoryList: [],
      page: 1,
      websiteUrl: "",
      searchText: "",
      isProcessing: true,
      isError: false,
    }
  );
  React.useEffect(() => {
    const f = async () => {
      try {
        const responses = await fetchProgramListPageData();
        let url = "";
        const contentRange = responses[0].headers["content-range"];
        const lastPage = isLastPage(contentRange);
        if (responses[2].data && responses[2].data[0]) {
          url = responses[2].data[0].website_url;
        }
        dispatch({
          type: "FETCH_SUCCESS",
          programList: responses[0].data,
          categoryList: responses[1].data,
          isLastPage: lastPage,
          url,
        });
      } catch (e) {
        console.error(e);
        dispatch({
          type: "FETCH_ERROR",
        });
      }
    };

    f();
  }, []);
  const authContext = React.useContext(AuthContext);

  const onDeleteProgram = async (programId, page) => {
    try {
      await deleteProgram(programId, authContext.user);
      const resp = await fetchProgramListByTitle(state.searchText, page);
      const contentRange = resp.headers["content-range"];
      const lastPage = isLastPage(contentRange);
      dispatch({
        type: "DELETED_SUCCESS",
        programList: resp.data,
        isLastPage: lastPage,
      });
    } catch (error) {
      console.log(error);
      dispatch({ type: "DELETED_ERROR" });
    }
  };

  const onSearchClicked = async (text) => {
    try {
      const resp = await fetchProgramListByTitle(text);
      const contentRange = resp.headers["content-range"];
      const lastPage = isLastPage(contentRange);
      dispatch({
        type: "SEARCH_SUCCESS",
        programList: resp.data,
        searchText: text,
        isLastPage: lastPage,
      });
    } catch (error) {
      console.log(error);
      dispatch({ type: "SEARCH_ERROR" });
    }
  };

  const onChangePage = async (page) => {
    try {
      const resp = await fetchProgramListByTitle(state.searchText, page);
      const contentRange = resp.headers["content-range"];
      const lastPage = isLastPage(contentRange);
      dispatch({
        type: "PAGE_CHANGED",
        programList: resp.data,
        page,
        isLastPage: lastPage,
      });
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <List
      programs={state.programList}
      websiteUrl={state.websiteUrl}
      categories={state.categoryList}
      page={state.page}
      isLastPage={state.isLastPage}
      onDeleteProgram={onDeleteProgram}
      onSearchClicked={onSearchClicked}
      onChangePage={onChangePage}
    />
  );
}

export function ProgramForm() {
  const [state, dispatch] = React.useReducer(
    (state, action) => {
      switch (action.type) {
        case "CATEGORY_LIST_FETCHED":
          return {
            ...state,
            categoryList: action.categoryList,
          };
        case "CHANNEL_LIST_FETCHED":
          return {
            ...state,
            channelList: action.channelList,
          };
        case "TAG_LIST_FETCHED":
          return {
            ...state,
            tagList: action.tagList,
          };
        case "SAVED_VIDEO":
          return {
            ...state,
            videoKey: action.key,
          };
        default:
          return state;
      }
    },
    {
      categoryList: [],
      channelList: [],
      tagList: [],
      videoKey: "",
    }
  );

  React.useEffect(() => {
    const f = async () => {
      const { data: categoryList } = await fetchCategoryList();
      dispatch({ type: "CATEGORY_LIST_FETCHED", categoryList });
    };

    f();
  }, []);

  React.useEffect(() => {
    const f = async () => {
      const { data: channelList } = await fetchBroadcastChannelList();
      dispatch({ type: "CHANNEL_LIST_FETCHED", channelList });
    };

    f();
  }, []);

  React.useEffect(() => {
    const f = async () => {
      const { data: tagList } = await fetchTagList();
      dispatch({ type: "TAG_LIST_FETCHED", tagList });
    };

    f();
  }, []);

  const authContext = React.useContext(AuthContext);
  const history = useHistory();

  const onSubmit = async (values) => {
    try {
      await createProgram(authContext.user, values);
      history.push("/");
    } catch (err) {
      console.error(err);
    }
  };

  const onUploadVideo = (key) => {
    dispatch({ type: "SAVED_VIDEO", key });
  };

  return (
    <CreateForm
      categoryList={state.categoryList}
      channelList={state.channelList}
      tagList={state.tagList}
      videoKey={state.videoKey}
      onThumbnailChange={onImageChange}
      onCoverPhotoChange={onImageChange}
      onSubmit={onSubmit}
      onUploadVideo={onUploadVideo}
    />
  );
}

export function ProgramDetails() {
  const params = useParams();
  const [state, dispatch] = React.useReducer(
    (s, action) => {
      switch (action.type) {
        case "FETCH_SUCCESS":
          return {
            ...s,
            program: action.program,
            videoKey: action.program.byteark,
            channelList: action.channelList,
            categoryList: action.categoryList,
            isProcessing: false,
            isError: false,
          };
        case "FETCH_ERROR":
          return {
            ...s,
            isProcessing: false,
            isError: true,
          };
        case "TAG_LIST_FETCHED":
          return {
            ...s,
            tagList: action.tagList,
          };
        case "SAVED_VIDEO":
          return {
            ...s,
            videoKey: action.key,
          };
        default:
          return s;
      }
    },
    {
      program: null,
      systemSetting: null,
      videoKey: "",
      categoryList: [],
      channelList: [],
      tagList: [],
      isProcessing: true,
      isError: false,
    }
  );
  React.useEffect(() => {
    const f = async () => {
      try {
        const responses = await fetchDetailsPageData(params.id);
        if (responses[0].data.length === 0) {
          throw new Error(`Program ID: ${params.id} not found.`);
        }
        const program = responses[0].data[0];
        program.program_tag.sort((t1, t2) => t1.rank - t2.rank);
        dispatch({
          type: "FETCH_SUCCESS",
          program,
          channelList: responses[1].data,
          categoryList: responses[2].data,
        });
      } catch (e) {
        console.error(e);
        dispatch({
          type: "FETCH_ERROR",
        });
      }
    };

    f();
  }, [params.id]);

  React.useEffect(() => {
    const f = async () => {
      const { data: tagList } = await fetchTagList();
      dispatch({ type: "TAG_LIST_FETCHED", tagList });
    };

    f();
  }, []);

  const authContext = React.useContext(AuthContext);
  const history = useHistory();

  const onSubmit = async (values) => {
    try {
      console.log(values);
      await updateProgram(authContext.user, params.id, values);
      history.push("/");
    } catch (err) {
      console.error(err);
    }
  };

  const onUploadVideo = (key) => {
    dispatch({ type: "SAVED_VIDEO", key });
  };

  if(!state.program) return <div></div>

  return (
    <Details
      program={state.program}
      categoryList={state.categoryList}
      channelList={state.channelList}
      tagList={state.tagList}
      videoKey={state.videoKey}
      onSubmit={onSubmit}
      onUploadVideo={onUploadVideo}
      onThumbnailChange={onImageChange}
      onCoverPhotoChange={onImageChange}
    />
  );
}

export async function fetchProgram(programId) {
  return axios.request({
    url: `/r-api/program?id=eq.${programId}&select=*,program_category(id,slug,title),program_tag(*)`,
    method: "GET",
    headers: {
      Accept: "application/vnd.pgrst.object+json",
    },
  });
}

async function fetchProgramListPageData(page = 1) {
  let offset = (page - 1) * 20;
  const programRequest = axios.get(
    `/r-api/program?deleted=eq.false&select=*,program_category(id,slug,title),user!created_by(*)&limit=20&offset=${offset}&order=id.desc`,
    { headers: { Prefer: "count=exact" } }
  );
  const categoryRequest = axios.get("/r-api/program_category");
  const systemRequest = axios.get("/r-api/system_settings");
  return axios.all([programRequest, categoryRequest, systemRequest]);
}

async function fetchProgramListByTitle(title, page = 1) {
  let offset = (page - 1) * 20;
  return axios.get(
    `/r-api/program?deleted=eq.false&title=like.*${title}*&select=*,program_category(id,slug,title),user!created_by(*)&limit=20&offset=${offset}&order=id.desc`,
    { headers: { Prefer: "count=exact" } }
  );
}

async function fetchDetailsPageData(id) {
  const programUrl = `/r-api/program?id=eq.${id}&select=*,program_category(id,slug,title),program_tag(*)`;
  const programRequest = axios.get(programUrl);
  const channelRequest = axios.get("/r-api/broadcast_channel");
  const categoryRequest = axios.get("/r-api/program_category");
  return axios.all([programRequest, channelRequest, categoryRequest]);
}

async function createProgram(user, program) {
  return axios.request({
    url: `/program-api/program`,
    method: "POST",
    data: {
      ...program,
      created_by: user.uid,
    },
  });
}

async function updateProgram(user, id, program) {
  return axios.request({
    url: `/program-api/program/${id}`,
    method: "PUT",
    data: {
      ...program,
      updated_by: user.uid,
    },
  });
}

async function onImageChange(image) {
  const formData = new FormData();
  formData.append("image", image);
  try {
    const {
      data: { link },
    } = await axios.request({
      url: `/program-static-api/images/`,
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: formData,
    });

    return link;
  } catch (e) {
    console.error(e);
  }
}

async function deleteProgram(id, user) {
  const url = `/program-api/program/${id}/`;
  return axios.request({
    url,
    method: "DELETE",
    data: {
      uid: user.uid,
    },
  });
}

function isLastPage(contentRange) {
  const regexp = /(\d+)/g;
  try {
    const list = [...contentRange.matchAll(regexp)];
    const lastIndex = parseInt(list[1], 10);
    const total = parseInt(list[2], 10);
    return lastIndex + 1 >= total;
  } catch (error) {
    console.log(error);
  }
  return true;
}
